import { useRef } from 'react'

import { useScrollAway } from '@/features/advertisement/hooks/useScrollAway'

export const useTopLeaderboardAd = () => {
  const ref = useRef<HTMLElement>(null)

  const { handleInViewChange, isSticky, scrollAway } = useScrollAway()

  return {
    scrollAway,
    isSticky,
    handleInViewChange,
    ref,
  }
}
